
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.999 4.002l.399.002c3.769.107 7.858 2.494 10.908 5.88a2.753 2.753 0 01-.004 3.66c-3.151 3.504-7.409 5.95-11.285 5.883-3.913.067-8.17-2.38-11.323-5.886a2.753 2.753 0 01.004-3.66c3.154-3.507 7.436-5.946 11.319-5.88h-.018zm0 2.57a5.143 5.143 0 10.34.011L12 6.571z","fill":"#373534","fill-rule":"evenodd"}})])
          )
        }
      }
    